import ResourceModal from './ResourceModal'
import React, { useContext, useEffect, useState } from 'react'
import { RootContext } from '../contexts/RootContext'
import FormInput from '../lib/FormInput'
import { Form } from 'react-bootstrap'

const InstrumentAlarmNoteModal = ({resource, show, onClose}) => {
  const [formState, setFormState] = useState({})
  const [errors, setErrors] = useState({})
  const { showMessage } = useContext(RootContext)

  useEffect(() => {
    setFormState({
      instrumentAlarmEvent: resource?.instrumentAlarmEvent(),
      note: resource?.note ?? ''
    })
  }, [resource]);

  const handleSubmit = async () => {
    resource.assignAttributes(formState)
    const msg = resource.persisted() ? 'Note updated' : 'Note created'
    try {
      await resource.save()
      showMessage(msg)
      onClose()
    } catch (_error) {
      let errors = {}
      resource.errors().toArray().forEach(error => errors[error.field] = error.detail)
      setErrors(errors)
    }
  }

  const handleInputChange = (ev) => {
    const name = ev.target.name
    const value = ev.target.value
    setFormState({...formState, [name]: value})
  }

  return (
    <ResourceModal show={show} onClose={onClose} onSubmit={handleSubmit} resource={resource} label="alarm event note">
      {resource && (
        <Form>
          <FormInput
            rows={6}
            name="note"
            value={formState.note}
            error={errors.note}
            onChange={handleInputChange}/>
        </Form>
      )}
    </ResourceModal>
  )
}

export default InstrumentAlarmNoteModal
